
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';

interface SuccessMessageProps {
  className?: string;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({ className = '' }) => {
  const { t } = useLanguage();
  
  return (
    <div className={`text-center py-12 animate-fade-in ${className}`}>
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-900/40 backdrop-blur-sm mb-4">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h2 className="text-2xl font-semibold text-white mb-4">
        {t('contactMe.success.title')}
      </h2>
      <p className="text-gray-300">
        {t('contactMe.success.message')}
      </p>
    </div>
  );
};

export default SuccessMessage;
